import * as menu from './menu.actions';
import { axiosClient } from '../../libs/axios';

export const tabs = {
    menu: 'menu',
    about: 'about',
    review: 'review',
};

export const GET_RESTAURANT_DATA = '[RESTAURANT APP] GET DATA';
export const SET_RESTAURANT_PARTIAL_DATA = '[RESTAURANT APP] GET PARTIAL DATA';
export const SHOW_RESTAURANT_TAB = '[RESTAURANT APP] SHOW TAB';

export function getRestaurantData() {
    return dispatch => {
        const restaurantCallback = (data) => {
            dispatch({
                type: GET_RESTAURANT_DATA,
                payload: {
                    ...data
                }
            });
            dispatch(menu.setMenuCategories(data.menu_categories))
        };
        
        return window.vendorData
            ? restaurantCallback(window.vendorData)
            : axiosClient.get(`/api/restaurant/${window.vendor}`)
                .then(response => {
                    restaurantCallback(response.data)
                })
    }
}

export function setRestaurantPartialData(data) {
    return {
        type: SET_RESTAURANT_PARTIAL_DATA,
        payload: data
    }
}

export function showTab(name) {
    return {
        type: SHOW_RESTAURANT_TAB,
        payload: name
    }
}
